<div class="app-sub-header">
    <div class="container">
        <h1 class="page-title red-color">Your Pinned Customer Overview</h1>
        <div
            class="sub-navigation flex justify-content-between align-items-center"
        >
            <ng-container>
                <div class="grouped-buttons">
                    <button class="grouped-button-left button-gray-bg" [routerLink]="['/collections']">All
                        <span></span></button>
                    <button class="grouped-button-right button-gray-bg selected"
                        [routerLink]="['/collections/pinned']">Pinned <span>{{noOfPinnedCollections}}</span></button>
                </div>

                <div class="grouped-buttons desktop-navigation">
                    <button class="grouped-button-left button-gray-bg"
                        [ngClass]="cardType === 'summary' ? 'selected' : ''" (click)="showSummary()">Summary</button>
                    <button class="grouped-button-right button-gray-bg"
                        [ngClass]="cardType === 'detailed' ? 'selected' : ''" (click)="showDetailed()">Detailed</button>
                </div>

                <div class="mobile-navigation">
                    <div class="checkbox-switch">
                        <input type="checkbox" checked="true" (change)="toggleCardState($event)" name="status"
                            class="input-checkbox" id="toolbar-active">
                        <div class="checkbox-animate">
                            <span class="checkbox-off">Detailed</span>
                            <span class="checkbox-on">Summary</span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<div class="main-wrapper">
    <div class="container no-padding">

        @if (cardType === 'summary') {
            <div class="grid">
                @for (collectionCard of collections; track $index) {
                    <div class="col-12 xl:col-4">
                        <cc-entity-card
                            [entity]="collectionCard"
                            [entityType]="EntityType.COLLECTION"
                            [entityStatus]="entityStatus"
                            [entityOverriddenStatuses]="entityOverriddenStatuses"
                            (cardPinToggle)="onCardPinToggle($event)"
                        ></cc-entity-card>
                    </div>
                }
            </div>
        }

        @if (cardType === 'detailed') {

            <p-tabs class="custom-no-bg" value="0">
                <p-tablist>
                    <p-tab value="0">
                        <span>
                            <img src="assets/svg/live-view.svg" />
                            <span>Live View</span>
                        </span>
                    </p-tab>
                    <p-tab value="1">
                        <span>
                            <img src="assets/svg/dashboard.svg" />
                            <span>History</span>
                        </span>
                    </p-tab>
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel value="0">
                        <div class="grid">
                            @for (collectionDetails of collectionDetailsList; track $index) {
                                <div class="col-12 xl:col-6">
                                    <cc-collection-details-view [username]="username" [selectedSite]="selectedSite"
                                        [collectionDetails]="collectionDetails" [pointsStatus]="entityStatus"></cc-collection-details-view>
                                </div>
                            }
                        </div>
                    </p-tabpanel>
                    <p-tabpanel value="1">
                        <div class="grid">
                            @if ((pointsObj | json) != '{}') {
                                <div class="col-12">
                                    <cc-historical-data [pointsObj]="pointsObj"></cc-historical-data>
                                </div>
                            }
                        </div>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        }
    </div>
</div>

<p-confirmDialog #cd [style]="{width: '50vw'}" [breakpoints]="{'640px': '90vw'}" [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        @let userHasWritePermission = (userHasWritePermission$ | async);
        @if (userHasWritePermission !== null) {
            <div class="flex justify-content-end">
                @if (!isOverrideResetOn || !userHasWritePermission) {
                    <eon-ui-button size="small" scheme="turquoise" text="Close" (click)="cd.onReject()"></eon-ui-button>
                }
                @if (isOverrideResetOn && userHasWritePermission) {
                    <eon-ui-button class="margin-right-1" size="small" scheme="turquoise" text="No" (click)="cd.onReject()"></eon-ui-button>
                    <eon-ui-button size="small" scheme="turquoise" text="Yes" (click)="cd.onAccept()"></eon-ui-button>
                }
            </div>
        }
    </ng-template>
</p-confirmDialog>
